/**
 * acctDisplayFooter.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2022 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";
import { Link } from "react-router-dom";

import { IconButton } from "@mui/material";

import { AuthContext } from "../auth/auth.context";

import { SCAvatar } from "../components/avatar.component";

export function AccountDisplayFooter(): React.ReactElement<any, any> {
  const authContext = React.useContext<AuthContext>(AuthContext);

  const membership = authContext.membership;
  if (!membership) { return <></>; }

  return <footer className="account-display-footer"
      data-user-id={membership.userID}
      data-account-id={membership.accountID}>
    <SCAvatar text={membership.avatarText || "XX"} url={membership.avatarUrl}/>
    <span className="member-name">{membership.firstname} {membership.lastname}</span>
    <span className="right-controls">
      <IconButton size="small" disableFocusRipple disableRipple disableTouchRipple
          component={Link} to="/group/profile">
        <i className="fa-solid fa-user" />
      </IconButton>
    </span>
  </footer>;
}
/*<IconButton size="small" disableFocusRipple disableRipple disableTouchRipple
          component={Link} to="/settings">
        <i className="fa-solid fa-gear" />
      </IconButton>*/
